import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const TEXT_AREA_PRINT_HEIGHT = "52px";

const colors = constants.colors;
const core500 = colors.ui.core[500];
const white = colors.ui.white[100];

const borderColor = core500;

export const containerStyles: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "16px",
};

export const guideRowsContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
};

export const topSeparatorStyles: CSSObject = {
  borderBottom: `4px solid ${borderColor}`,
};

export const guideLabelCell: CSSObject = {
  position: "relative",
  overflow: "hidden",
  borderRight: `4px solid ${borderColor}`,
  "> div": {
    position: "absolute",
    inset: 0,
    padding: 8,
    display: "flex",
    alignItems: "center",
    "> label": {
      display: "inline-flex",
      alignItems: "center",
      overflow: "hidden",
      height: "100%",
      lineHeight: "100%",
    },
  },
};

export const guideRow: CSSObject = {
  display: "grid",
  gridTemplateColumns: "315px 1fr",
  gridTemplateRows: "1fr auto",
  alignItems: "stretch",
  padding: "6px 0",
  background: white,
  borderBottom: `2px solid ${borderColor}`,
  minHeight: "55px",

  ":last-of-type": {
    borderBottom: "none",
  },
};

export const textAreaCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
  marginLeft: "8px",
  background: white,
  height: TEXT_AREA_PRINT_HEIGHT,
  minHeight: TEXT_AREA_PRINT_HEIGHT,
  maxHeight: TEXT_AREA_PRINT_HEIGHT,
};

export const textAreaCounterCss: CSSObject = {
  gridColumn: "1 / -1",
  textAlign: "right",
};
